// Errors already sent to Sentry; a catch-all reporter skips anything whose cause chain holds one.
const reportedErrors = new WeakSet<object>();

const MAX_CAUSE_DEPTH = 5;

export const markAsReported = (error: unknown) => {
  if (typeof error === 'object' && error !== null) {
    reportedErrors.add(error);
  }
};

export const wasReported = (error: unknown, depth = 0): boolean => {
  if (typeof error !== 'object' || error === null || depth > MAX_CAUSE_DEPTH) {
    return false;
  }
  if (reportedErrors.has(error)) {
    return true;
  }

  return wasReported((error as { cause?: unknown }).cause, depth + 1);
};
